'use strict';

var $ = require('jquery');

//viewpoint endlesss scrolling
if( $('.viewpoint-list-container').length > 0 ){
    $(window).on('DOMMouseScroll mousewheel touchend keydown',function(e) {
		
        if( ( e.originalEvent.keyCode == 40 || e.originalEvent.wheelDelta < 0 || e.originalEvent.detail > 0  ) && $(window).scrollTop() + $(window).height() >= $(document).height() ){
            cust_get_more_viewpoints('.viewpoint-list-container');
        }
    });
}

$(document).on('ready', function(){
	$('.load-viewpoints').on('click', function(){
		cust_get_more_viewpoints('.viewpoint-list-container');
	});
});

$('.loader').hide();

function cust_get_more_viewpoints(selector, async){
		// Don't fire multiple times
		if( !$(selector).hasClass('loading') ){
			// Fetch next page with ajax
			$.ajax({
				url: page.admin_ajax,
				dataType: 'json',
				type: 'POST',
				async: async,
				data: {
					action: 'cust_load_viewpoints',
					perPage: $(selector).data('per-page'),
					page: $(selector).data('pages'),
				},
				beforeSend: function(data){
					// Increment current page
                    $(selector).data('pages', $(selector).data('pages') + 1 );
					// Toggle load text and loader icon visibility
					$('.loader').show();
					$('.loadmore').hide();
					// Add loading class so not firing multiple times
					$(selector).addClass('loading');
				},
				complete: function(data) {

					// // Check if we got more posts
					if(data.responseJSON != ''){
						// Add all posts separately to DOM
						var $posts = $(data.responseJSON);
						$posts.each(function(index,elem){
							$(elem).hide();
							$(selector).append(elem);
							$(elem).fadeIn();
						});
						// Remove loading class after 800ms
						window.setTimeout(function(){
							$(selector).removeClass('loading');
						},800);
					}

					// Toggle load text and loader icon visibility
					$('.loader').hide();
					$('.loadmore').show();
				}
			});
	}
}